<script setup lang="ts">

import ChangeLanguage from "@/components/navBar/languages/ChangeLanguage.vue";
import NavBarSearchField from "@/components/inputs/NavBarSearchField.vue";
import UserDimensions from "@/components/navBar/dimensions/UserDimensions.vue";
import UserSection from "@/components/navBar/userSection/UserSection.vue";
import SupportDateAlerts from "@/components/settings/SupportDateAlerts.vue";

let props = defineProps({
  isVisible: {type: Boolean, required: true}
});

</script>

<template>
  <div class="tw-flex tw-justify-between tw-items-center tw-w-full desktop:tw-hidden tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-deep-dark">
    <q-slide-transition>
      <div class="tw-py-3 tw-px-2 tw-flex tw-flex-col tw-gap-2 tw-w-full" v-show="isVisible">
        <NavBarSearchField/>
        <SupportDateAlerts/>
        <div class="tw-flex tw-justify-between tw-items-center tw-gap-2">
          <div class="tw-flex tw-justify-start tw-items-center tw-gap-2">
            <ChangeLanguage/>
            <UserDimensions/>
          </div>
          <div class="tw-flex tw-justify-end tw-items-center">
            <UserSection/>
          </div>
        </div>

      </div>
    </q-slide-transition>
  </div>
</template>

<style scoped>

</style>
